import { Feather } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import React from "react";
import { useCallback } from "react";
import { useTheme } from "@towersystems/roam-common-native";
import { QuickKey as BaseQuickKey } from "../../../QuickKey";
import useOnline from "@towersystems/roam-common-native/lib/utilities/use-online";

export const SalesHistoryQuickKey = React.forwardRef<any, unknown>(
  (_props, ref) => {
    const { colors: Colors } = useTheme();
    const navigation = useNavigation<any>();
    const online = useOnline();

    const backgroundColor = Colors.action;

    const onPress = useCallback(() => {
      navigation.navigate("SalesRootScreen");
    }, []);

    return (
      <BaseQuickKey
        ref={ref}
        disabled={!online}
        label="Sales History"
        onPress={onPress}
        iconPrimary={
          <Feather name="list" size={24} color={Colors.quickKeyActionText} />
        }
        backgroundColor={backgroundColor}
        isDestructive={false}
        isAction={true}
      />
    );
  }
);
